__turbopack_context__.v({
  "component": "x2NdaW_component",
  "component__body": "x2NdaW_component__body",
  "component__body_dark": "x2NdaW_component__body_dark",
  "component__button": "x2NdaW_component__button",
  "component__close": "x2NdaW_component__close",
  "component__close_dark": "x2NdaW_component__close_dark",
  "component__dialog": "x2NdaW_component__dialog",
  "component__dialogPanel": "x2NdaW_component__dialogPanel",
  "component__dialogScrim": "x2NdaW_component__dialogScrim",
  "component__frontierLogo": "x2NdaW_component__frontierLogo",
  "component__header": "x2NdaW_component__header",
  "component__helperText": "x2NdaW_component__helperText",
  "component__icon": "x2NdaW_component__icon",
  "component__list": "x2NdaW_component__list",
  "component__modalChrome": "x2NdaW_component__modalChrome",
  "component__modalContainer": "x2NdaW_component__modalContainer",
  "component__modalContainer_dark": "x2NdaW_component__modalContainer_dark",
  "component__steps": "x2NdaW_component__steps",
  "component__text": "x2NdaW_component__text",
  "hide-for-large": "x2NdaW_hide-for-large",
  "hide-for-large-only": "x2NdaW_hide-for-large-only",
  "hide-for-medium": "x2NdaW_hide-for-medium",
  "hide-for-medium-only": "x2NdaW_hide-for-medium-only",
  "hide-for-small-only": "x2NdaW_hide-for-small-only",
  "show-for-large": "x2NdaW_show-for-large",
  "show-for-large-only": "x2NdaW_show-for-large-only",
  "show-for-medium": "x2NdaW_show-for-medium",
  "show-for-medium-only": "x2NdaW_show-for-medium-only",
  "show-for-small-only": "x2NdaW_show-for-small-only",
  "u-color-black": "x2NdaW_u-color-black",
  "u-color-blue": "x2NdaW_u-color-blue",
  "u-color-midnight": "x2NdaW_u-color-midnight",
  "u-color-primary-dark": "x2NdaW_u-color-primary-dark",
  "u-color-red": "x2NdaW_u-color-red",
  "u-color-white": "x2NdaW_u-color-white",
  "u-theme-black": "x2NdaW_u-theme-black",
  "u-theme-blue": "x2NdaW_u-theme-blue",
  "u-theme-dark": "x2NdaW_u-theme-dark",
  "u-theme-light": "x2NdaW_u-theme-light",
  "u-theme-red": "x2NdaW_u-theme-red",
  "u-theme-white": "x2NdaW_u-theme-white",
});
